<ul class="tree-view">
  <t-dossier-tree-item [item]="tree.rootItem" [treeComponent]="this"></t-dossier-tree-item>
</ul>